module.exports = require("./lrc-IQ");